import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActorSendGroupStatusInformationModel, ActorStatusInformationModel } from 'src/app/models/api/actor-status-information.model';
import { Subscription } from 'rxjs';
import { CreateColumn, CreateNonTypedColumn, TableColumn } from 'src/app/models/tableColumn';
import { RequestStatusService } from '../requeststatus.service';
import { DataTypeEnum } from 'src/app/constants/data-type.enum';

@Component({
  selector: 'app-request-status-actor-list',
  templateUrl: './request-status-actor-list.component.html'
})
export class RequestStatusActorListComponent implements OnDestroy, OnInit {

  columnsToDisplay: TableColumn[] = [
    CreateColumn<ActorStatusInformationModel>("fullName", 'FullName', DataTypeEnum.General, 2, false),
    CreateColumn<ActorStatusInformationModel>("email", 'Email', DataTypeEnum.General, 2, true),
    CreateColumn<ActorStatusInformationModel>("phone", 'Phone', DataTypeEnum.General, 1, true),
    CreateColumn<ActorStatusInformationModel>("language", 'Language', DataTypeEnum.General, 1, true),
    CreateColumn<ActorStatusInformationModel>("action", 'Action', DataTypeEnum.ActorAction, 1, true),
    CreateColumn<ActorStatusInformationModel>("documentName", 'DocumentName', DataTypeEnum.General, 3, true),
    CreateColumn<ActorStatusInformationModel>("deadline", 'Deadline', DataTypeEnum.DateTime, 1, true),
  ];

  requestGuid!: string;
  actors: ActorSendGroupStatusInformationModel[] = [];
  private requestSubscription!: Subscription;
  private listenSubscription!: Subscription;
  private actorListSubscription!: Subscription;
  sendGroups: ActorSendGroupStatusInformationModel[] = [];
  constructor(private requestStatusService: RequestStatusService) {
    // start listening for requestguid and any changes
    this.requestSubscription = this.requestStatusService.selectedRequest$.subscribe(request => {
      // model was reset/deleted
      if (Object.keys(request).length === 0) {
        // no request, nothing to do?
        return;
      }

      // we have a request
      this.requestGuid = request.id;

      // check if actions can be added (rights issue) and make sure it is not added double
      let actionColumnToAddAndVerify: TableColumn = CreateNonTypedColumn('actions', '', DataTypeEnum.General, 1, false);
      let hasEditRightsForRequest = this.requestStatusService.hasUserEditRights();
      let indexOfColumn = this.columnsToDisplay.findIndex(column => column.columnName === actionColumnToAddAndVerify.columnName);
      let columnAlreadyAdded = indexOfColumn >= 0;
      // you should be allowed to do actions, but the column has not been added:
      if (hasEditRightsForRequest && !columnAlreadyAdded) {
        this.columnsToDisplay.push(actionColumnToAddAndVerify); // add it
      }
      // have we added the column while this was NOT needed (since we changed request)
      if (!hasEditRightsForRequest && columnAlreadyAdded) {
        this.columnsToDisplay.splice(indexOfColumn);// remove it
      }

    });

  }
  ngOnInit(): void {
    // listen to what new actors are pushed:
    this.actorListSubscription = this.requestStatusService.actors$.subscribe(actors => {
      this.actors = actors;
      this.sendGroups = actors;
    });
  }

  ngOnDestroy() {
    // verify and unsubscribe
    if (this.requestSubscription) {
      this.requestSubscription.unsubscribe();
    }
    // verify and unsubscribe
    if (this.actorListSubscription) {
      this.actorListSubscription.unsubscribe();
    }
  }

}
